<template>
    <form
        class="flex flex-col gap-6"
        @submit.prevent="handleUpdate"
    >
        <CoreStringInput
            id="role_name"
            ref="roleNameInput"
            placeholder="§permissions.ui_set_new_role_name"
            name="role_name"
            :fullWidth="true"
            v-model="roleName"
            :disabled="settingsStore.updating_role"
            required
            :aria-describedby="roleName.length === 0 ? 'role-name-error' : null"
        />

        <CoreCheckbox
            id="internal_role"
            label="§ui_button.checkbox_internal"
            v-model="isInternal"
            :disabled="settingsStore.updating_role"
        />

        <div
            class="flex gap-2"
            role="group"
            aria-label="Form actions"
        >
            <CoreButton
                label="§ui_button.save"
                type="submit"
                :loading="settingsStore.updating_role"
                :disabled="!isValid || settingsStore.updating_role || settingsStore.deleting_role"
                icon="pi-save"
            />

            <CoreButton
                v-if="!confirmDelete"
                type="button"
                label="§ui_button.confirm_deletion"
                variant="danger"
                @click="askConfirmDelete"
                :disabled="settingsStore.updating_role"
                :danger="true"
                icon="pi-trash"
            />

            <CoreButton
                v-if="confirmDelete"
                type="button"
                label="§ui_button.delete"
                variant="danger"
                @click="handleDelete"
                :disabled="settingsStore.updating_role || settingsStore.deleting_role"
                :danger="true"
                icon="pi-trash"
            />

            <CoreButton
                label="§ui_button.cancel"
                type="button"
                variant="tertiary"
                @click="handleClose"
                :disabled="settingsStore.updating_role"
                icon="pi-times"
            />
        </div>
    </form>
</template>

<script>
import { useSettingsStore } from '@/stores/settings'
import { useModalStore } from '@/stores/modal'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreCheckbox from '@/components/core/CoreCheckbox.vue'

export default {
    name: 'EditRoleModal',

    components: {
        CoreStringInput,
        CoreButton,
        CoreCheckbox,
    },

    data() {
        return {
            settingsStore: useSettingsStore(),
            modalStore: useModalStore(),
            roleId: null,
            roleName: '',
            isInternal: false,
            confirmDelete: false,
        }
    },

    computed: {
        isValid() {
            return this.roleName.trim().length > 0
        },
    },

    mounted() {
        this.roleName = this.modalStore.data.name || ''
        this.roleId = this.modalStore.data.id || null
        this.isInternal = this.modalStore.data.is_internal || false
        setTimeout(() => {
            if (this.$refs.roleNameInput && this.$refs.roleNameInput.$el) {
                this.$refs.roleNameInput.$el.firstChild.focus()
            } else if (this.$refs.roleNameInput && this.$refs.roleNameInput.focus) {
                this.$refs.roleNameInput.focus()
            }
        }, 300)
    },

    methods: {
        async handleUpdate() {
            await this.settingsStore.updateRole(this.roleId, {
                name: this.roleName.trim(),
                is_internal: this.isInternal,
            })
            this.handleClose()
        },

        askConfirmDelete() {
            this.confirmDelete = true
        },

        async handleDelete() {
            await this.settingsStore.deleteRole(this.roleId)
            this.handleClose()
        },

        handleClose() {
            this.modalStore.setClose()
        },
    },
}
</script>
